import { modifier } from 'constant'
import { cn } from 'utils'
import { useEvent } from 'hooks'
import * as tabSelectors from './tab.selector'

export const TabComponent = (() => {
	const activateContainerItem = (container: HTMLElement, index: number) => {
		const { children } = container
		if (!children) {
			return
		}

		for (let i = 0, { length } = children; i < length; i++) {
			const child = children[i] as HTMLElement
			if (i !== index) {
				cn.removeClass(child, modifier.active)
			} else {
				cn.addClass(child, modifier.active)
			}
		}
	}

	const setHandlerAction = (children: HTMLCollection, el: HTMLButtonElement, container: HTMLElement, index: number) => {
		const click = useEvent(el, 'click')

		click.register(() => {
			for (let i = 0, { length } = children; i < length; i++) {
				cn.removeClass(children[i] as HTMLElement, modifier.active)
			}
			cn.addClass(el, modifier.active)
			activateContainerItem(container, index)
		})
	}

	const initHandlers = () => {
		const handlers = tabSelectors.getHandlersContainers()
		if (!handlers) {
			return
		}

		for (let i = 0, { length } = handlers; i < length; i++) {
			const handler = handlers[i]
			const { children, parentNode } = handler
			if (!parentNode) {
				continue
			}

			const container = tabSelectors.getContainer(parentNode as HTMLElement)

			for (let j = 0, childsLength = children.length; j < childsLength; j++) {
				const child = children[j]
				if (!(child instanceof HTMLButtonElement)) {
					continue
				}
				setHandlerAction(children, child, container, j)
			}
		}
	}

	const init = () => {
		initHandlers()
	}

	return {
		init,
	}
})()
